/* CALMEA nav pill.

   Tracks the hovered / focused top-level header link and slides one Sage pill
   under it. Position comes from getBoundingClientRect rather than offsetLeft:
   the list items are position:relative so the pill can sit behind them, which
   would make offsetLeft measure from the <li> and always read 0.

   Keyboard focus moves the pill exactly like the pointer does. On mouseleave
   or focusout the pill returns to the current page's link, and fades out if
   this page is not in the menu.

   Below 1024px nothing is attached and the pill is hidden in CSS.
*/
(function () {
  function init() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    var list = nav.querySelector('.list-menu--inline');
    if (!list || list.querySelector('.cal-navpill')) return;

    var candidates = list.querySelectorAll('a.header__menu-item, summary.header__menu-item');
    var items = [];
    var i;
    for (i = 0; i < candidates.length; i++) {
      if (!candidates[i].closest('.header__submenu')) items.push(candidates[i]);
    }
    if (!items.length) return;

    var mq = window.matchMedia('(min-width: 1024px)');

    var pill = document.createElement('span');
    pill.className = 'cal-navpill';
    pill.setAttribute('aria-hidden', 'true');
    list.insertBefore(pill, list.firstChild);

    var parked = null;
    for (i = 0; i < items.length; i++) {
      if (items[i].getAttribute('aria-current') === 'page' || items[i].querySelector('.header__active-menu-item')) {
        parked = items[i];
        break;
      }
    }

    var current = null;

    function moveTo(el, animate) {
      if (!mq.matches) return;
      if (!el) {
        pill.style.opacity = '0';
        current = null;
        return;
      }
      var listRect = list.getBoundingClientRect();
      var rect = el.getBoundingClientRect();
      if (!animate) pill.style.transition = 'none';
      pill.style.width = rect.width + 'px';
      pill.style.transform = 'translate(' + (rect.left - listRect.left) + 'px, -50%)';
      pill.style.opacity = '1';
      if (!animate) {
        void pill.offsetWidth;
        pill.style.transition = '';
      }
      current = el;
    }

    function park() {
      moveTo(parked, true);
    }

    function target(node) {
      if (!node || !node.closest) return null;
      var el = node.closest('a.header__menu-item, summary.header__menu-item');
      if (!el || items.indexOf(el) === -1) return null;
      return el;
    }

    list.addEventListener('mouseover', function (event) {
      var el = target(event.target);
      if (el) moveTo(el, true);
    });

    nav.addEventListener('mouseleave', park);

    list.addEventListener('focusin', function (event) {
      var el = target(event.target);
      if (el) moveTo(el, true);
    });

    list.addEventListener('focusout', function (event) {
      if (!list.contains(event.relatedTarget)) park();
    });

    function sync() {
      if (!mq.matches) {
        pill.style.opacity = '0';
        return;
      }
      moveTo(current || parked, false);
    }

    window.addEventListener('resize', sync);
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }

    sync();

    /* Web fonts change the link widths after first paint. */
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(sync);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();